// extracted by mini-css-extract-plugin
export default {"root":"RowActionsButton_root__gSNx-"};